import React, { useEffect, useRef } from "react";
import { motion, useInView } from "framer-motion";
import strategy from "../../Assets/strategy.jpeg";
import "./Strategy.css";

const Strategy = () => {

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);
    const ref4 = useRef(null);

    // Check when each box comes into view
    const inView1 = useInView(ref1, { once: true, threshold: 0.2 });
    const inView2 = useInView(ref2, { once: true, threshold: 0.2 });
    const inView3 = useInView(ref3, { once: true, threshold: 0.2 });
    const inView4 = useInView(ref4, { once: true, threshold: 0.2 });

    const boxVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (delay) => ({
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, delay }
        }),
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className="strategy-container">
                <div className="strategy-topic">
                    <h1>Strategy Building</h1>
                </div>
                <div className="def">
                    <span className="def-content">Strategy building for a company involves creating a structured plan to achieve business goals through market research, competitive analysis, and targeted marketing efforts.
                        In digital marketing, this means developing a data-driven approach for branding, lead generation, and
                        customer engagement across online channels. A strong strategy ensures better ROI, consistent growth, and a clear roadmap for success.
                    </span>
                </div>
                <div className="SB-benefits" style={{ marginLeft: "5%" }}>
                    <h2 className="SB-question">Benefits of Digital marketing:-</h2>
                    <div className="fullDM-content">
                        <span className="DM-content" style={{ marginTop: "15px", flexDirection: "column"}}>Building a strong strategy is essential for business success,
                            as it provides a clear direction and ensures efficient decision-making. Here are some key benefits:
                            <ul className="ul-points">
                                <li className="point">Clear Business Goals – Defines objectives and creates a structured path to achieve them.</li>
                                <li className="point">Better Resource Allocation – Ensures time, budget, and efforts are used effectively.</li>
                                <li className="point">Improved Decision-Making – Data-driven strategies lead to smarter, more informed choices.</li>
                                <li className="point">Higher ROI – Optimized marketing and operations drive better results and profitability.</li>
                            </ul>
                        </span>
                        <div className="digi-image">
                            <img style={{ width: "350px", height: "450px" }} className="apps-img" src={strategy} alt="apps" />
                        </div>
                    </div>
                </div>
                <div className="SB-benefits" >
                    <h1 className="DM-nextquestion">Services we provide to upscale your business !</h1>
                    <div className="boxes">
                        <motion.div
                            ref={ref1}
                            initial="hidden"
                            animate={inView1 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0}
                            className="point-box"
                        >
                            <h2 className="point-topic">Campaigns & Roadmap</h2>
                            <span className="point-content">Strategy building services for campaigns and roadmaps include market research, goal setting,
                                and creating a structured execution plan to ensure successful marketing efforts. This involves defining key milestones,
                                selecting the right marketing channels, and optimizing campaigns for maximum impact and measurable results.</span>
                        </motion.div>

                        <motion.div
                            ref={ref2}
                            initial="hidden"
                            animate={inView2 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.3}
                            className="point-box"
                        >
                            <h2 className="point-topic">Campaign Audits</h2>
                            <span className="point-content">Campaign audit services involve analyzing past and ongoing marketing
                                campaigns to assess their effectiveness, identify gaps, and optimize performance. This includes reviewing key metrics,
                                audience engagement, ad spend efficiency, and overall strategy to improve future campaigns and maximize ROI.</span>
                        </motion.div>

                        <motion.div
                            ref={ref3}
                            initial="hidden"
                            animate={inView3 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.6}
                            className="point-box"
                        >
                            <h2 className="point-topic">Conversion Rate Optimisation</h2>
                            <span className="point-content">Conversion Rate Optimization (CRO) services focus on improving website and campaign performance to increase the percentage of visitors who take desired actions,
                                such as making a purchase or filling out a form. This includes A/B testing, user experience enhancements,
                                landing page improvements, and data-driven adjustments to boost engagement and maximize conversions.</span>
                        </motion.div>

                        <motion.div
                            ref={ref4}
                            initial="hidden"
                            animate={inView4 ? "visible" : "hidden"}
                            variants={boxVariants}
                            custom={0.9}
                            className="point-box"
                        >
                            <h2 className="point-topic">CRM solutions</h2>
                            <span className="point-content">CRM (Customer Relationship Management) solutions help businesses manage and improve interactions with customers by organizing data,
                                tracking leads, and automating sales and marketing processes. These solutions enhance customer engagement,
                                streamline communication, and provide valuable insights to boost retention, sales, and overall business growth.</span>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Strategy;